export default __webpack_public_path__ + "baea02630777758256edd45f65b6deb5.svg";